const { createEvent } = require('./application/service');
const DomainEvent = require('./domain/model/domain.event');

/**
 * Permite guardar y publicar un evento.
 * @param {DomainEvent} event objeto evento
 */
async function publish(event) {
  try {
    return await createEvent(event);
  } catch (error) {
    return Promise.resolve(true);
  }
}

module.exports = {
  DomainEvent,
  publish
};
